import { combine } from 'effector';
export function or() {
  for (var _len = arguments.length, stores = new Array(_len), _key = 0; _key < _len; _key++) {
    stores[_key] = arguments[_key];
  }

  return combine({
    and: [stores, values => values.reduce((all, current) => Boolean(all) || Boolean(current))],
    or: {
      sid: "-44722k"
    }
  });
}